import axios from 'axios';
// import router from '../../router/index.js';

/**
 * Helper to get base URL and auth token
 */
const getApiConfig = () => {
  const userToken = localStorage.getItem('userToken');
  if (!userToken) {
    router.push({ name: 'login' });
    throw new Error('User not authenticated.');
  }
  
  const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
  return {
    baseURL,
    headers: { Authorization: `Bearer ${userToken}` }
  };
};

// --- STATE ---
const state = {
  searchResults: [],
  isLoading: false,
};

// --- MUTATIONS ---
const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_RESULTS(state, results) {
    state.searchResults = results || [];
  },
  CLEAR_RESULTS(state) {
    state.searchResults = [];
  },
};

// --- ACTIONS ---
const actions = {
  /**
   * Performs a search for packed items
   */
  async performSearch({ commit }, { searchParams }) {
    commit('SET_LOADING', true);
    commit('CLEAR_RESULTS');
    
    try {
      const { baseURL, headers } = getApiConfig();
      const response = await axios.get(`${baseURL}/box-search`, {
        params: searchParams,
        headers: headers
      });
      commit('SET_RESULTS', response.data);
      return response.data;
    } catch (error) {
      // If 404 (Not Found), it's a valid "no results" response
      if (error.response && error.response.status === 404) {
        commit('SET_RESULTS', []);
        return [];
      }
      // For other errors, re-throw them for the component to handle
      console.error('Error in performSearch (boxes):', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
